import { useState, useMemo, useEffect } from "react";
import { DashboardCard, MetricCard } from "../../../component/new-ui/cards";
import { TeamAvailability } from "../../../component/icons/user-dashboard";
import { pkr, usd } from "../../../component/custom-hooks/capitalizeWords";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import moment from "moment";

// ─── DATA ─────────────────────────────────────────────────────────────────────
// const FX_RATE = 279.2;
const FX_DATE = "Mar 5, 2026";
const TODAY_DAY = 5;
const BANK_BAL = 6686;
const BANK_AS_OF = "Feb 13, 2026";
const NEXT_REM = "~Feb 28, 2026";

const MONTHS_DATA = {
  "March 2026": { remIn: 0, remUSD: 0, wht: 0, expOut: 0, openBal: 6686 },
  "February 2026": { remIn: 5364642, remUSD: 19100, wht: 13353, expOut: 5358611, openBal: 655 },
  "January 2026": { remIn: 5827894, remUSD: 21000, wht: 14570, expOut: 4630710, openBal: 0 },
};

const LOC_BUDGET = { Ittehad: 716514, "Phase 8": 259633, "Phase 8 II": 73000, Remote: 240903 };
const LOC_ACTUAL = { Ittehad: 560059, "Phase 8": 215063, "Phase 8 II": 0, Remote: 172641 };

const OVERDUE_BILLS = [
  { id: 1, month: "January", expense: "Expert Cool (AC Service)", loc: "Ittehad", cat: "Maintenance", pkr: 28000 },
  { id: 2, month: "January", expense: "Daisy Tech Repairs", loc: "Ittehad", cat: "Repairs", pkr: 89050 },
  { id: 3, month: "January", expense: "Generator — Ittehad", loc: "Ittehad", cat: "Generator", pkr: 55000 },
  { id: 4, month: "January", expense: "Security — Phase 8", loc: "Phase 8", cat: "Security", pkr: 32000 },
  { id: 5, month: "January", expense: "Security — Ittehad", loc: "Ittehad", cat: "Security", pkr: 32000 },
  { id: 6, month: "January", expense: "Aquafina — Ittehad", loc: "Ittehad", cat: "Groceries", pkr: 6840 },
];

const UPCOMING_BILLS = [
  { id: 7, month: "March", expense: "Rent — Ittehad", loc: "Ittehad", cat: "Rent", pkr: 329450, dueDay: 1 },
  { id: 8, month: "March", expense: "Rent — Phase 8", loc: "Phase 8", cat: "Rent", pkr: 65000, dueDay: 1 },
  { id: 9, month: "March", expense: "Rent — Remote", loc: "Remote", cat: "Rent", pkr: 55000, dueDay: 1 },
  { id: 10, month: "March", expense: "Rent — Phase 8 II", loc: "Phase 8 II", cat: "Rent", pkr: 65000, dueDay: 1 },
  { id: 11, month: "March", expense: "Security — Ittehad", loc: "Ittehad", cat: "Security", pkr: 32500, dueDay: 1 },
  { id: 12, month: "March", expense: "Security — Phase 8", loc: "Phase 8", cat: "Security", pkr: 32500, dueDay: 1 },
  { id: 13, month: "March", expense: "Maintenance — Ittehad", loc: "Ittehad", cat: "Maintenance", pkr: 34000, dueDay: 5 },
  { id: 14, month: "March", expense: "Maintenance — Phase 8", loc: "Phase 8", cat: "Maintenance", pkr: 6500, dueDay: 5 },
  { id: 15, month: "March", expense: "Maintenance — Remote", loc: "Remote", cat: "Maintenance", pkr: 6500, dueDay: 5 },
  { id: 16, month: "March", expense: "Maintenance — Phase 8 II", loc: "Phase 8 II", cat: "Maintenance", pkr: 8000, dueDay: 5 },
  { id: 17, month: "March", expense: "Aquafina — Ittehad", loc: "Ittehad", cat: "Groceries", pkr: 6840, dueDay: 10 },
  { id: 18, month: "March", expense: "Generator — Ittehad", loc: "Ittehad", cat: "Generator", pkr: 55000, dueDay: 10 },
  { id: 19, month: "March", expense: "Generator — Phase 8", loc: "Phase 8", cat: "Generator", pkr: 35000, dueDay: 10 },
  { id: 20, month: "March", expense: "Internet — Ittehad (x3)", loc: "Ittehad", cat: "Internet", pkr: 52724, dueDay: 15 },
  { id: 21, month: "March", expense: "Internet — Phase 8", loc: "Phase 8", cat: "Internet", pkr: 14633, dueDay: 15 },
  { id: 22, month: "March", expense: "Internet — Remote (x2)", loc: "Remote", cat: "Internet", pkr: 59403, dueDay: 15 },
  { id: 23, month: "March", expense: "Electricity — Ittehad", loc: "Ittehad", cat: "Electricity", pkr: 200000, dueDay: null },
  { id: 24, month: "March", expense: "Electricity — Phase 8", loc: "Phase 8", cat: "Electricity", pkr: 100000, dueDay: null },
  { id: 25, month: "March", expense: "Electricity — Remote", loc: "Remote", cat: "Electricity", pkr: 120000, dueDay: null },
];

const LOC_COLORS = { Ittehad: "#4f6ef7", "Phase 8": "#7c5ce0", "Phase 8 II": "#14b8a6", Remote: "#f97316" };
const LOC_EMOJI = { Ittehad: "🏢", "Phase 8": "🏢", "Phase 8 II": "🏗", Remote: "🌐" };
const CAT_ICONS = { Salaries: "👥", Rent: "🏠", Electricity: "⚡", Internet: "📡", Generator: "🔋", Maintenance: "🔧", Security: "🔒", Groceries: "💧", "Bank Charges": "🏦", Repairs: "🛠" };
const NAV_TABS = ["Dashboard", "Bills", "Tracker", "Reports", "Config"];

// const pkr = n => n == null ? "—" : "Rs " + Number(n).toLocaleString("en-PK");
// const usd = (n, fx) => n == null ? "—" : "$" + (n / fx).toLocaleString("en", { maximumFractionDigits: 0 });
const ord = d => { if (!d) return null; const s = ["th", "st", "nd", "rd"], v = d % 100; return d + (s[(v - 20) % 10] || s[v] || s[0]); };

function DualAmt({ pkrVal, fxRate, size = "md", colorPKR, colorUSD, usdVal }) {
  const sizes = { lg: { pkr: 30, usd: 17 }, md: { pkr: 18, usd: 13 }, sm: { pkr: 14, usd: 11 } };
  const s = sizes[size] || sizes.md;
  return (
    <div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
      <span style={{ fontSize: s.pkr, fontWeight: 800, color: colorPKR || "#111827", fontFamily: "'Outfit', sans-serif", letterSpacing: -0.5, lineHeight: 1 }}>
        {pkr(pkrVal)}
      </span>
      <span style={{ fontSize: s.usd, fontWeight: 600, color: colorUSD || "#6b7280", fontFamily: "'Outfit', sans-serif" }}>
        {usd(usdVal)}
      </span>
    </div>
  );
}

const globalCss = `
  .loc-row:hover { background: #f1f5f9 !important; }
  .loc-row.active:hover { filter: brightness(0.97); }
  .bill-item:hover { filter: brightness(0.97); }
  select option { background: #fff; color: #111827; }
`;

export default function Dashboard() {
  const apiCall = useApiCall();

  const [activeTab, setActiveTab] = useState("Dashboard");
  const [locFilter, setLocFilter] = useState("All");
  const [selectedMonth, setSelectedMonth] = useState("February 2026");

  const [apiData, setApiData] = useState({});
  const [isLoading, setIsLoading] = useState(true)

  const C = {
    navBg: "#1a1d24",
    pageBg: "#EDE8E1",
    cardBg: "#ffffff",
    accent: "#4f6ef7",
    purple: "#7c5ce0",
    green: "#16a34a",
    red: "#dc2626",
    blue: "#0095FF",
    amber: "#d97706",
    textPri: "#111827",
    textSec: "#4b5563",
    textMut: "#9ca3af",
    border: "rgba(0,0,0,0.07)",
    shadow: "0 1px 2px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.06)",
    shadowMd: "0 2px 4px rgba(0,0,0,0.05), 0 8px 24px rgba(0,0,0,0.08)",
  };
  const card = (x = {}) => ({
    background: C.cardBg,
    borderRadius: 16,
    border: `1px solid ${C.border}`,
    boxShadow: C.shadow,
    ...x,
  });

  const FX_RATE = apiData?.nav_strip?.fx_rate || 279.2;

  const mData = MONTHS_DATA[selectedMonth] || MONTHS_DATA["February 2026"];
  // const filteredOverdue = locFilter === "All" ? OVERDUE_BILLS : OVERDUE_BILLS.filter(b => b.loc === locFilter);
  const filteredOverdue = apiData?.nav_strip?.overdue_query || [];
  // const filteredUpcoming = locFilter === "All" ? UPCOMING_BILLS : UPCOMING_BILLS.filter(b => b.loc === locFilter);

  const filteredUpcoming = apiData?.nav_strip?.dueSoonQuery || [];

  const filteredOvTotal = filteredOverdue.reduce((s, b) => s + b.amount, 0);
  const filteredUpTotal = filteredUpcoming.reduce((s, b) => s + b.amount, 0);
  const filteredCashNeed = filteredOvTotal + filteredUpTotal;
  const shortfall = filteredCashNeed - BANK_BAL;

  // const locRows = useMemo(() => Object.keys(LOC_COLORS).map(loc => ({
  //   loc,
  //   budget: LOC_BUDGET[loc] || 0,
  //   actual: LOC_ACTUAL[loc] || 0,
  //   overdueAmt: OVERDUE_BILLS.filter(b => b.loc === loc).reduce((s, b) => s + b.pkr, 0),
  //   upcomingAmt: UPCOMING_BILLS.filter(b => b.loc === loc).reduce((s, b) => s + b.pkr, 0),
  // })), []);

  const locRows = apiData?.office_breakdown?.map((eachLocation, i) => ({
    loc: eachLocation?.name,
    budget: eachLocation?.budget || 0,
    actual: eachLocation?.actual || 0,
    overdueAmt: eachLocation?.overdue_amt || 0,
    upcomingAmt: eachLocation?.upcoming_amt || 0,
  }))

  const netFlow = mData.remIn - mData.expOut;

  const getData = async() => {
    try {
      const apiRes = await apiCall({method: "get", url: "cash-flow/dashboard/overview"});
      setApiData(apiRes?.data);
      setIsLoading(false)
    } catch (error) {
      console.log("Err", error)
    }
  }

  useEffect(() => {
    getData();
  }, [])

  return (
    <>
      <style>{globalCss}</style>
      <div className="overflow-auto flex flex-col">

        {/* ── PAGE ── */}
        <div style={{ flex: 1, padding: "24px 0px", width: "100%", margin: "0 auto" }}>

          {/* Header row */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>
            <div>
              <h1 style={{ fontSize: 22, fontWeight: 800, color: C.textPri, letterSpacing: -0.5, margin: 0 }}>Dashboard</h1>
              <p style={{ fontSize: 13, color: C.textSec, marginTop: 3 }}>Today is {ord(TODAY_DAY)} March 2026</p>
            </div>

            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {/* Location pills */}
              {/* <div style={{ display: "flex", gap: 3, padding: 4, borderRadius: 12, background: "#fff", border: `1px solid ${C.border}`, boxShadow: C.shadow }}>
                {["All", "Ittehad", "Phase 8", "Remote", "Phase 8 II"].map(loc => {
                  const active = locFilter === loc;
                  const bg = active ? (loc === "All" ? C.accent : LOC_COLORS[loc]) : "transparent";
                  return (
                    <button key={loc} onClick={() => setLocFilter(loc)} style={{
                      padding: "5px 13px", borderRadius: 8, border: "none", cursor: "pointer",
                      fontSize: 12, fontWeight: 600,
                      background: bg, color: active ? "#fff" : C.textSec,
                      transition: "all 0.15s", whiteSpace: "nowrap",
                    }}>
                      {loc === "All" ? "All Offices" : loc}
                    </button>
                  );
                })}
              </div> */}
              {/* Month */}
              <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} style={{
                padding: "8px 14px", borderRadius: 10, border: `1px solid ${C.border}`,
                background: "#fff", fontSize: 13, fontWeight: 600, color: C.textPri,
                cursor: "pointer", boxShadow: C.shadow, outline: "none",
                fontFamily: "'DM Sans', sans-serif",
              }}>
                {Object.keys(MONTHS_DATA)?.map(m => <option key={m}>{m}</option>)}
              </select>
            </div>
          </div>

          {/* ── ROW 1: Cash Need + Running Balance ── */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 14, marginBottom: 14 }}>

            {/* Cash Need Hero */}
            <div style={card({
              padding: "28px 32px",
              // background: "linear-gradient(135deg, #fff1f2 0%, #fef2f2 100%)",
              // border: "1px solid #fecaca",
              display: "flex", alignItems: "center", justifyContent: "space-between", gap: 24,
            })}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                  <div style={{ width: 42, height: 42, borderRadius: 12, background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>💸</div>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: C.red, letterSpacing: 0.8, textTransform: "uppercase" }}>Cash Needed to Clear All Bills</div>
                    <div style={{ fontSize: 12, color: "#9f1239", marginTop: 2 }}>Overdue carryovers + all March bills</div>
                  </div>
                </div>
                <DualAmt pkrVal={apiData?.nav_strip?.amount_need} fxRate={FX_RATE} usdVal={(apiData?.nav_strip?.amount_need / FX_RATE).toFixed(2)} size="lg" colorPKR={C.red} colorUSD="#ef4444" />
                <div style={{ marginTop: 14 }}>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 14, padding: "7px 14px", borderRadius: 20, background: "#fef2f2", border: "1px solid #fecaca", fontSize: 12 }}>
                    <span><span style={{ color: "#9f1239" }}>Balance: </span><span style={{ fontWeight: 700, color: C.red }}>{pkr(apiData?.nav_strip?.bank_balance)}</span></span>
                    <span style={{ color: "#fecaca" }}>·</span>
                    <span><span style={{ color: "#9f1239" }}>Shortfall: </span><span style={{ fontWeight: 700, color: C.red }}>{pkr(apiData?.nav_strip?.shortfall)}</span></span>
                    <span style={{ color: "#9f1239", opacity: 0.5 }}>{usd(apiData?.nav_strip?.shortfall/FX_RATE)}</span>
                  </div>
                </div>
              </div>
              {/* Chips */}
              <div style={{ display: "flex", flexDirection: "column", gap: 10, flexShrink: 0, minWidth: 230 }}>
                <div style={{ padding: "14px 18px", borderRadius: 12, background: "#fef2f2", border: "1px solid #fecaca" }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: C.red, letterSpacing: 0.7, textTransform: "uppercase", marginBottom: 7 }}>⚠ Overdue · {apiData?.nav_strip?.overdue_count} bills</div>
                  <DualAmt pkrVal={apiData?.nav_strip?.overdue_total} usdVal={Number(apiData?.nav_strip?.overdue_total?.replaceAll(",","")) / FX_RATE} fxRate={FX_RATE} size="md" colorPKR={C.red} colorUSD="#ef4444" />
                </div>
                <div style={{ padding: "14px 18px", borderRadius: 12, background: "#fffbeb", border: "1px solid #fde68a" }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: C.amber, letterSpacing: 0.7, textTransform: "uppercase", marginBottom: 7 }}>📋 Due This Month · {apiData?.nav_strip?.due_soon_count} bills</div>
                  <DualAmt pkrVal={apiData?.nav_strip?.due_soon_total} usdVal={Number(apiData?.nav_strip?.due_soon_total?.replaceAll(",","")) / FX_RATE} fxRate={FX_RATE} size="md" colorPKR={C.amber} colorUSD="#d97706" />
                </div>
              </div>
            </div>

            {/* Running Balance */}
            <div style={card({
              padding: "28px 28px",
              // background: BANK_BAL < 50000 ? "linear-gradient(160deg,#fffbeb,#fef9c3)" : "linear-gradient(160deg,#f5f7ff,#eef1ff)",
              // border: BANK_BAL < 50000 ? "1px solid #fde68a" : "1px solid #c7d2fe",
              display: "flex", flexDirection: "column", justifyContent: "space-between",
            })}>
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
                  <div style={{ width: 44, height: 44, borderRadius: 13, background: apiData?.running_balance?.is_low ? "#fef9c3" : "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>🏦</div>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: apiData?.running_balance?.is_low ? C.amber : C.accent, letterSpacing: 0.8, textTransform: "uppercase" }}>
                      Running Balance
                      {apiData?.running_balance?.is_low && <span style={{ marginLeft: 7, padding: "2px 7px", borderRadius: 20, background: "#fef9c3", border: "1px solid #fde68a", fontSize: 10 }}>⚠ LOW</span>}
                    </div>
                  </div>
                </div>
                <DualAmt pkrVal={apiData?.running_balance?.bank_balance} usdVal={apiData?.running_balance?.bank_balance/FX_RATE} fxRate={FX_RATE} size="lg" colorPKR={apiData?.running_balance?.is_low ? C.amber : C.accent} colorUSD={apiData?.running_balance?.is_low ? "#d97706" : "#6366f1"} />
              </div>
              <div style={{ marginTop: 20, paddingTop: 16, borderTop: `1px solid ${apiData?.running_balance?.is_low ? "#fde68a" : "#c7d2fe"}` }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <div style={{ fontSize: 10, color: C.textMut, marginBottom: 2 }}>Balance as of</div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: C.textPri }}>{apiData?.running_balance?.bank_balance_as_of}</div>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ fontSize: 10, color: C.textMut, marginBottom: 2 }}>Next remittance</div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: C.amber }}>{moment().endOf("month").format("DD MMM YYYY")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── ROW 2: KPI cards ── */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 14, marginBottom: 14 }}>
            {[
              { label: "Remittances In", pkrVal: apiData?.kpi_row?.remittances_in?.pkr, usdVal: apiData?.kpi_row?.remittances_in?.pkr_usd_eq, sub: apiData?.kpi_row?.remittances_in?.sub, color: C.green, icon: "🏦", iconBg: "#dcfce7" }, //'#EDE9FE'
              { label: "Expenses Out", pkrVal: apiData?.kpi_row?.expenses_out?.pkr, usdVal: apiData?.kpi_row?.expenses_out?.pkr_usd_eq, sub: apiData?.kpi_row?.expenses_out?.sub, color: C.red, icon: "📤", iconBg: "#FEE2E2"},
              // { label: "Net Cash Flow", pkrVal: apiData?.kpi_row?.net_flow?.pkr, usdVal: apiData?.kpi_row?.net_flow?.pkr_usd_eq, sub: apiData?.kpi_row?.net_flow?.pkr >= 0 ? "Surplus" : "Deficit", color: apiData?.kpi_row?.net_flow?.pkr >= 0 ? C.green : C.red, icon: "⚖️", iconBg: "#E0F2FE" },
              { label: "Net Cash Flow", pkrVal: apiData?.kpi_row?.net_flow?.pkr, usdVal: apiData?.kpi_row?.net_flow?.pkr_usd_eq, sub: apiData?.kpi_row?.net_flow?.pkr >= 0 ? "Surplus" : "Deficit", color: C.blue, icon: "⚖️", iconBg: "#E0F2FE" },
              { label: "Petty Cash", pkrVal: apiData?.kpi_row?.petty_cash?.pkr, usdVal: apiData?.kpi_row?.petty_cash?.pkr_usd_eq, sub: apiData?.kpi_row?.petty_cash?.sub, color: C.purple, icon: "💵", iconBg: "#EDE9FE"},
              { label: "WHT Deducted", pkrVal: apiData?.kpi_row?.wht_deducted?.pkr, usdVal: apiData?.kpi_row?.wht_deducted?.pkr_usd_eq, sub: apiData?.kpi_row?.wht_deducted?.sub, color: C.amber, icon: "💰", iconBg: "#fef3c7" },
            ].map((k, i) => (
              <MetricCard
                icon={<span>{k.icon}</span>}
                iconColor={C.green}
                iconBg={k.iconBg}
                valueColor={C.green}
                value={<DualAmt pkrVal={k.pkrVal} usdVal={k.usdVal} fxRate={FX_RATE} size="md" colorPKR={k.color} colorUSD={k.color + "bb"} />}
                statsBadge={k.sub}
                label={k.label}
              />
            ))}
          </div>

          {/* ── ROW 3: Office Breakdown + Bills ── */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14 }}>
            <DashboardCard
              Icon={<TeamAvailability />}
              iconColor={'bg-theme-blue-light text-theme-blue'}
              heading="By Office"
              subHeading={'Expense distribution by office location'}
              DataNotFoundText={`By Office`}
              footer={null}
              loading={isLoading}
              condition={locRows?.length}
              moreOff={false}
            >
              <div className="px-7 pt-5 flex flex-col gap-2.5" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {locRows?.map(({ loc, budget, actual, overdueAmt, upcomingAmt }) => {
                  const color = LOC_COLORS[loc];
                  const pct = budget > 0 ? Math.min((actual / budget) * 100, 100) : 0;
                  const isActive = locFilter === loc;
                  const totalOwed = overdueAmt + upcomingAmt;
                  return (
                    <div key={loc}
                      className={`loc-row${isActive ? " active" : ""}`}
                      // onClick={() => setLocFilter(locFilter === loc ? "All" : loc)}
                      style={{
                        padding: "13px 15px", borderRadius: 12, cursor: "pointer",
                        background: isActive ? `${color}0f` : "#f8f9fb",
                        border: `1.5px solid ${isActive ? color + "55" : C.border}`,
                        transition: "all 0.15s",
                      }}>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 9 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontSize: 15 }}>{LOC_EMOJI[loc]}</span>
                          <span style={{ fontSize: 13, fontWeight: 700, color: isActive ? color : C.textPri }}>{loc}</span>
                        </div>
                        <DualAmt pkrVal={actual} fxRate={FX_RATE} size="sm" colorPKR={color} colorUSD={C.textMut} />
                      </div>
                      <div style={{ height: 5, background: "#e9ecef", borderRadius: 3, overflow: "hidden", marginBottom: 7 }}>
                        <div style={{ height: "100%", width: `${pct}%`, background: color, borderRadius: 3, transition: "width 0.4s ease" }} />
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ fontSize: 10.5, color: C.textMut }}>Budget: {pkr(budget)}</span>
                        {totalOwed > 0
                          ? <span style={{ fontSize: 10.5, fontWeight: 700, color: overdueAmt > 0 ? C.red : C.amber }}>
                            {overdueAmt > 0 ? <>⚠ {pkr(totalOwed)} owed</> : <>📋 {pkr(totalOwed)} due</>}
                          </span>
                          : <span style={{ fontSize: 10.5, color: C.green, fontWeight: 600 }}>✓ Clear</span>
                        }
                      </div>
                    </div>
                  );
                })}
              </div>
            </DashboardCard>

            <DashboardCard
              Icon={<TeamAvailability />}
              iconColor={'bg-theme-red-light text-theme-red'}
              heading="Overdue Bills"
              subHeading={'Unpaid bills requiring immediate attention'}
              DataNotFoundText={`Overdue Bills`}
              footer={null}
              loading={isLoading}
              condition={filteredOverdue?.length}
              moreOff={false}
            >
              <div className="px-7 pt-5 w-full h-full flex flex-col justify-between">
                <div style={{ display: "flex", flexDirection: "column", gap: 7, marginBottom: 14 }}>
                  {filteredOverdue?.map(b => (
                    <div key={b.id} className="bill-item" style={{
                      padding: "13px 15px", borderRadius: 12, cursor: "pointer",
                      background: "#f8f9fb",
                      border: `1.5px solid ${C.border}`,
                      transition: "all 0.15s",
                      display: "flex",
                      justifyContent: "space-between"
                    }}>
                      <div className="flex items-center gap-3">
                        <span style={{ fontSize: 15, flexShrink: 0 }}>{CAT_ICONS[b.category] || "💳"}</span>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: "#000", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: 'block', marginBottom: "3px" }}>{b.expense}</div>
                          <div style={{ fontSize: 10, color: "#0b0b0b", marginTop: 2, display: "flex", alignItems: "center", gap: 5 }}>
                            <span style={{ padding: "1px 6px", borderRadius: 20, background: `${LOC_COLORS[b.loc]}18`, color: LOC_COLORS[b.loc], fontSize: 9, fontWeight: 700 }}>{b.location}</span>
                            <span>{b.month}</span>
                          </div>
                        </div>
                      </div>
                      <div style={{ textAlign: "right", flexShrink: 0 }}>
                        <div style={{ fontSize: 12.5, fontWeight: 800, color: C.red }}>{pkr(b.amount)}</div>
                        {/* <div style={{ fontSize: 10, color: "#0b0b0b", opacity: 0.8 }}>{usd(b.pkr, FX_RATE)}</div> */}
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ padding: "12px 16px", borderRadius: 11, background: "#fef2f2", border: "1px solid #fecaca", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: "#9f1239" }}>Total Overdue</span>
                  <DualAmt pkrVal={filteredOvTotal} fxRate={FX_RATE} size="sm" colorPKR={C.red} colorUSD="#ef4444" />
                </div>
              </div>
            </DashboardCard>

            <DashboardCard
              Icon={<TeamAvailability />}
              iconColor={'bg-theme-orange-light text-theme-orange'}
              heading="Upcoming"
              subHeading={'Bills approaching due date soon'}
              DataNotFoundText={`Upcoming`}
              footer={null}
              loading={false}
              condition={filteredUpcoming?.length}
              moreOff={false}
            >
              <div className="px-7 pt-5 w-full h-full flex flex-col justify-between">
                <div style={{ flex: 1, overflowY: "auto", maxHeight: 340, display: "flex", flexDirection: "column", gap: 6, marginBottom: 14 }}>
                  {filteredUpcoming?.map(b => {
                    const locColor = LOC_COLORS[b.loc] || C.accent;
                    
                    return (
                      <div key={b.id} className="bill-item" style={{
                        padding: "13px 15px", borderRadius: 12, cursor: "pointer",
                        background: "#f8f9fb",
                        border: `1.5px solid ${C.border}`,
                        transition: "all 0.15s",
                        display: "flex",
                        justifyContent: "space-between"
                      }}>
                        <div className="flex items-center gap-3">
                          <span style={{ fontSize: 14, flexShrink: 0 }}>{CAT_ICONS[b.category] || "💳"}</span>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 12, fontWeight: 500, color: C.textPri, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: 'block', marginBottom: "3px" }}>{b.expense}</div>
                            <div style={{ fontSize: 10, color: C.textMut, marginTop: 2, display: "flex", alignItems: "center", gap: 4 }}>
                              <span style={{ padding: "1px 6px", borderRadius: 20, background: `${locColor}18`, color: locColor, fontSize: 9, fontWeight: 700 }}>{b.location}</span>

                              <span>{b.due_date ? moment(b.due_date).format("DD MMM YYYY") : "On receipt"}</span>

                              {/* {(isLate || isToday) && <span style={{ color: C.red, fontWeight: 700 }}>⚠ Overdue</span>}
                              {isSoon && <span style={{ color: C.amber, fontWeight: 700 }}>⚡ Soon</span>} */}
                            </div>
                          </div>
                        </div>
                        <div style={{ textAlign: "right", flexShrink: 0 }}>
                          {/* <div style={{ fontSize: 12.5, fontWeight: 800, color: isLate || isToday ? C.amber : C.green }}>{pkr(b.pkr)}</div> */}
                          <div style={{ fontSize: 12.5, fontWeight: 800, color: C.green }}>{pkr(b.amount)}</div>
                          {/* <div style={{ fontSize: 10, color: "#0b0b0b", opacity: 0.8 }}>{usd(b.pkr, FX_RATE)}</div> */}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{ padding: "12px 16px", borderRadius: 11, background: "#fffbeb", border: "1px solid #fde68a", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontSize: 12, fontWeight: 700, color: "#92400e" }}>Total Due</span>
                  <DualAmt pkrVal={filteredUpTotal} fxRate={FX_RATE} size="sm" colorPKR={C.amber} colorUSD="#d97706" />
                </div>
              </div>
            </DashboardCard>
          </div>
        </div>
      </div>
    </>
  );
}

function Dot() {
  return <span style={{ fontSize: 11, color: "rgba(255,255,255,0.15)", margin: "0 12px" }}>·</span>;
}

// import { useState, useMemo } from "react";

// // ─── DATA ─────────────────────────────────────────────────────────────────────
// const FX_RATE = 279.2;
// const FX_DATE = "Mar 5, 2026";
// const TODAY_DAY = 5;
// const BANK_BAL = 6686;
// const BANK_AS_OF = "Feb 13, 2026";
// const NEXT_REM = "~Feb 28, 2026";

// const MONTHS_DATA = {
//   "March 2026": { remIn: 0, remUSD: 0, wht: 0, expOut: 0, openBal: 6686 },
//   "February 2026": { remIn: 5364642, remUSD: 19100, wht: 13353, expOut: 5358611, openBal: 655 },
//   "January 2026": { remIn: 5827894, remUSD: 21000, wht: 14570, expOut: 4630710, openBal: 0 },
// };

// const LOC_BUDGET = { Ittehad: 716514, "Phase 8": 259633, "Phase 8 II": 73000, Remote: 240903 };
// const LOC_ACTUAL = { Ittehad: 560059, "Phase 8": 215063, "Phase 8 II": 0, Remote: 172641 };

// const OVERDUE_BILLS = [
//   { id: 1, month: "January", expense: "Expert Cool (AC Service)", loc: "Ittehad", cat: "Maintenance", pkr: 28000, dueDay: null },
//   { id: 2, month: "January", expense: "Daisy Tech Repairs", loc: "Ittehad", cat: "Repairs", pkr: 89050, dueDay: null },
//   { id: 3, month: "January", expense: "Generator — Ittehad", loc: "Ittehad", cat: "Generator", pkr: 55000, dueDay: 10 },
//   { id: 4, month: "January", expense: "Security — Phase 8", loc: "Phase 8", cat: "Security", pkr: 32000, dueDay: 1 },
//   { id: 5, month: "January", expense: "Security — Ittehad", loc: "Ittehad", cat: "Security", pkr: 32000, dueDay: 1 },
//   { id: 6, month: "January", expense: "Aquafina — Ittehad", loc: "Ittehad", cat: "Groceries", pkr: 6840, dueDay: 10 },
// ];

// const UPCOMING_BILLS = [
//   // Due today or overdue within March (dueDay < TODAY_DAY)
//   { id: 7, month: "March", expense: "Rent — Ittehad", loc: "Ittehad", cat: "Rent", pkr: 329450, dueDay: 1 },
//   { id: 8, month: "March", expense: "Rent — Phase 8", loc: "Phase 8", cat: "Rent", pkr: 65000, dueDay: 1 },
//   { id: 9, month: "March", expense: "Rent — Remote", loc: "Remote", cat: "Rent", pkr: 55000, dueDay: 1 },
//   { id: 10, month: "March", expense: "Rent — Phase 8 II", loc: "Phase 8 II", cat: "Rent", pkr: 65000, dueDay: 1 },
//   { id: 11, month: "March", expense: "Security — Ittehad", loc: "Ittehad", cat: "Security", pkr: 32500, dueDay: 1 },
//   { id: 12, month: "March", expense: "Security — Phase 8", loc: "Phase 8", cat: "Security", pkr: 32500, dueDay: 1 },
//   // Due today (5th)
//   { id: 13, month: "March", expense: "Maintenance — Ittehad", loc: "Ittehad", cat: "Maintenance", pkr: 34000, dueDay: 5 },
//   { id: 14, month: "March", expense: "Maintenance — Phase 8", loc: "Phase 8", cat: "Maintenance", pkr: 6500, dueDay: 5 },
//   { id: 15, month: "March", expense: "Maintenance — Remote", loc: "Remote", cat: "Maintenance", pkr: 6500, dueDay: 5 },
//   { id: 16, month: "March", expense: "Maintenance — Phase 8 II", loc: "Phase 8 II", cat: "Maintenance", pkr: 8000, dueDay: 5 },
//   // Upcoming
//   { id: 17, month: "March", expense: "Aquafina — Ittehad", loc: "Ittehad", cat: "Groceries", pkr: 6840, dueDay: 10 },
//   { id: 18, month: "March", expense: "Generator — Ittehad", loc: "Ittehad", cat: "Generator", pkr: 55000, dueDay: 10 },
//   { id: 19, month: "March", expense: "Generator — Phase 8", loc: "Phase 8", cat: "Generator", pkr: 35000, dueDay: 10 },
//   { id: 20, month: "March", expense: "Internet — Ittehad (x3)", loc: "Ittehad", cat: "Internet", pkr: 52724, dueDay: 15 },
//   { id: 21, month: "March", expense: "Internet — Phase 8", loc: "Phase 8", cat: "Internet", pkr: 14633, dueDay: 15 },
//   { id: 22, month: "March", expense: "Internet — Remote (x2)", loc: "Remote", cat: "Internet", pkr: 59403, dueDay: 15 },
//   { id: 23, month: "March", expense: "Electricity — Ittehad", loc: "Ittehad", cat: "Electricity", pkr: 200000, dueDay: null },
//   { id: 24, month: "March", expense: "Electricity — Phase 8", loc: "Phase 8", cat: "Electricity", pkr: 100000, dueDay: null },
//   { id: 25, month: "March", expense: "Electricity — Remote", loc: "Remote", cat: "Electricity", pkr: 120000, dueDay: null },
// ];

// const LOC_COLORS = { Ittehad: "#4f6ef7", "Phase 8": "#7c5ce0", "Phase 8 II": "#14b8a6", Remote: "#f97316" };
// const LOC_EMOJI = { Ittehad: "🏢", "Phase 8": "🏢", "Phase 8 II": "🏗", Remote: "🌐" };
// const CAT_ICONS = { Salaries: "👥", Rent: "🏠", Electricity: "⚡", Internet: "📡", Generator: "🔋", Maintenance: "🔧", Security: "🔒", Groceries: "💧", "Bank Charges": "🏦", Repairs: "🛠" };
// const NAV_TABS = ["Dashboard", "Bills", "Tracker", "Reports", "Config"];

// const pkr = n => n == null ? "—" : "₨ " + Number(n).toLocaleString("en-PK");
// const usd = (n, fx) => n == null ? "—" : "$" + (n / fx).toLocaleString("en", { maximumFractionDigits: 0 });
// const fmt = n => n >= 1000000 ? (n / 1000000).toFixed(2) + "M" : n >= 1000 ? (n / 1000).toFixed(1) + "K" : n.toLocaleString();
// const ord = d => { if (!d) return null; const s = ["th", "st", "nd", "rd"], v = d % 100; return d + (s[(v - 20) % 10] || s[v] || s[0]); };

// // ─── DUAL AMOUNT — PKR + USD equal weight ─────────────────────────────────────
// function DualAmt({ pkrVal, fxRate, size = "md", colorPKR, colorUSD }) {
//   const sizes = { lg: { pkr: 32, usd: 18 }, md: { pkr: 18, usd: 13 }, sm: { pkr: 14, usd: 11 } };
//   const s = sizes[size] || sizes.md;
//   return (
//     <div style={{ display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap" }}>
//       <span style={{ fontSize: s.pkr, fontWeight: 800, color: colorPKR || "#111827", letterSpacing: -0.5, lineHeight: 1 }}>
//         {pkr(pkrVal)}
//       </span>
//       <span style={{ fontSize: s.usd, fontWeight: 600, color: colorUSD || "#6b7280", }}>
//         {usd(pkrVal, fxRate)}
//       </span>
//     </div>
//   );
// }

// // ─── MAIN ─────────────────────────────────────────────────────────────────────
// export default function Dashboard() {
//   const [activeTab, setActiveTab] = useState("Dashboard");
//   const [locFilter, setLocFilter] = useState("All");
//   const [selectedMonth, setSelectedMonth] = useState("February 2026");

//   const C = {
//     navBg: "#1e2128", pageBg: "#EDE8E1", cardBg: "#ffffff",
//     accent: "#4f6ef7", purple: "#7c5ce0", green: "#16a34a", red: "#dc2626", amber: "#d97706",
//     textPri: "#111827", textSec: "#6b7280", textMut: "#9ca3af",
//     border: "rgba(0,0,0,0.08)", shadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.08)",
//   };
//   const card = (x = {}) => ({ background: C.cardBg, borderRadius: 14, border: `1px solid ${C.border}`, boxShadow: C.shadow, ...x });

//   const mData = MONTHS_DATA[selectedMonth] || MONTHS_DATA["February 2026"];

//   // Cash need
//   const overdueTotal = OVERDUE_BILLS.reduce((s, b) => s + b.pkr, 0);
//   const upcomingTotal = UPCOMING_BILLS.reduce((s, b) => s + b.pkr, 0);
//   const cashNeed = overdueTotal + upcomingTotal;

//   // Location filtered
//   const filteredOverdue = locFilter === "All" ? OVERDUE_BILLS : OVERDUE_BILLS.filter(b => b.loc === locFilter);
//   const filteredUpcoming = locFilter === "All" ? UPCOMING_BILLS : UPCOMING_BILLS.filter(b => b.loc === locFilter);
//   const filteredOvTotal = filteredOverdue.reduce((s, b) => s + b.pkr, 0);
//   const filteredUpTotal = filteredUpcoming.reduce((s, b) => s + b.pkr, 0);
//   const filteredCashNeed = filteredOvTotal + filteredUpTotal;

//   // Due soon (today ±5 days)
//   const dueSoon = UPCOMING_BILLS.filter(b => b.dueDay && b.dueDay >= TODAY_DAY && b.dueDay <= TODAY_DAY + 5);

//   // Location breakdown (for selected month)
//   const locRows = useMemo(() => {
//     return Object.keys(LOC_COLORS).map(loc => ({
//       loc,
//       budget: LOC_BUDGET[loc] || 0,
//       actual: LOC_ACTUAL[loc] || 0,
//       overdueAmt: OVERDUE_BILLS.filter(b => b.loc === loc).reduce((s, b) => s + b.pkr, 0),
//       upcomingAmt: UPCOMING_BILLS.filter(b => b.loc === loc).reduce((s, b) => s + b.pkr, 0),
//     }));
//   }, []);

//   return (
//     <div className="flex flex-col overflow-auto">
//       {/* ══ PAGE ══ */}
//       <div style={{ flex: 1, padding: "24px 0px", width: "100%", margin: "0 auto" }}>

//         {/* Top controls */}
//         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
//           <div>
//             <h1 style={{ fontSize: 22, fontWeight: 800, color: C.textPri, letterSpacing: -0.5, margin: 0 }}>Dashboard</h1>
//             <p style={{ fontSize: 13, color: C.textSec, marginTop: 3 }}>Today is {ord(TODAY_DAY)} March 2026</p>
//           </div>
//           <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
//             {/* Location filter */}
//             <div style={{ display: "flex", gap: 3, padding: 4, borderRadius: 10, background: "#fff", border: `1px solid ${C.border}`, boxShadow: C.shadow }}>
//               {["All", "Ittehad", "Phase 8", "Remote", "Phase 8 II"].map(loc => (
//                 <button key={loc} onClick={() => setLocFilter(loc)} style={{
//                   padding: "5px 11px", borderRadius: 7, border: "none", cursor: "pointer", fontSize: 11, fontWeight: 600,
//                   background: locFilter === loc ? (loc === "All" ? C.accent : LOC_COLORS[loc]) : "transparent",
//                   color: locFilter === loc ? "#fff" : C.textSec, transition: "all 0.15s", whiteSpace: "nowrap",
//                 }}>{loc === "All" ? "All Offices" : loc}</button>
//               ))}
//             </div>
//             {/* Month picker */}
//             <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}
//               style={{ padding: "8px 14px", borderRadius: 10, border: `1px solid ${C.border}`, background: "#fff", fontSize: 13, fontWeight: 600, color: C.textPri, cursor: "pointer", boxShadow: C.shadow, outline: "none" }}>
//               {Object.keys(MONTHS_DATA).map(m => <option key={m}>{m}</option>)}
//             </select>
//           </div>
//         </div>

//         {/* ══ HERO — CASH NEED (full width, dominant) ══ */}
//         <div style={{
//           ...card({
//             padding: "28px 32px", marginBottom: 16,
//             background: "linear-gradient(135deg,#fff1f2,#fef2f2)",
//             border: "1px solid #fecaca",
//             display: "grid", gridTemplateColumns: "1fr auto", gap: 24, alignItems: "center",
//           })
//         }}>
//           <div>
//             <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
//               <div style={{ width: 44, height: 44, borderRadius: 12, background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>💸</div>
//               <div>
//                 <div style={{ fontSize: 12, fontWeight: 700, color: C.red, letterSpacing: 0.8, textTransform: "uppercase" }}>Cash Needed to Clear All Bills</div>
//                 <div style={{ fontSize: 12, color: "#9f1239", marginTop: 1 }}>Overdue carryovers + all March bills</div>
//               </div>
//             </div>
//             {/* THE number */}
//             <DualAmt pkrVal={filteredCashNeed} fxRate={FX_RATE} size="lg" colorPKR={C.red} colorUSD="#ef4444" />
//             {/* Balance gap */}
//             <div style={{ marginTop: 14, display: "flex", alignItems: "center", gap: 8 }}>
//               <div style={{ padding: "6px 14px", borderRadius: 20, background: "#fef2f2", border: "1px solid #fecaca", fontSize: 12 }}>
//                 <span style={{ color: "#9f1239" }}>Current balance: </span>
//                 <span style={{ fontWeight: 700, color: C.red }}>{pkr(BANK_BAL)}</span>
//                 <span style={{ color: "rgba(0,0,0,0.2)", margin: "0 8px" }}>·</span>
//                 <span style={{ color: "#9f1239" }}>Shortfall: </span>
//                 <span style={{ fontWeight: 700, color: C.red }}>{pkr(filteredCashNeed - BANK_BAL)}</span>
//                 <span style={{ color: "rgba(0,0,0,0.2)", margin: "0 8px" }}>·</span>
//                 <span style={{ color: "rgba(0,0,0,0.35)" }}>{usd(filteredCashNeed - BANK_BAL, FX_RATE)}</span>
//               </div>
//             </div>
//           </div>
//           {/* Breakdown chips */}
//           <div style={{ display: "flex", flexDirection: "column", gap: 10, minWidth: 260 }}>
//             <div style={{ padding: "14px 18px", borderRadius: 12, background: "#fef2f2", border: "1px solid #fecaca" }}>
//               <div style={{ fontSize: 10, fontWeight: 700, color: C.red, letterSpacing: 0.7, textTransform: "uppercase", marginBottom: 6 }}>⚠ Overdue ({filteredOverdue.length} bills)</div>
//               <DualAmt pkrVal={filteredOvTotal} fxRate={FX_RATE} size="md" colorPKR={C.red} colorUSD="#ef4444" />
//             </div>
//             <div style={{ padding: "14px 18px", borderRadius: 12, background: "#fffbeb", border: "1px solid #fde68a" }}>
//               <div style={{ fontSize: 10, fontWeight: 700, color: C.amber, letterSpacing: 0.7, textTransform: "uppercase", marginBottom: 6 }}>📋 Due This Month ({filteredUpcoming.length} bills)</div>
//               <DualAmt pkrVal={filteredUpTotal} fxRate={FX_RATE} size="md" colorPKR={C.amber} colorUSD="#d97706" />
//             </div>
//           </div>
//         </div>

//         {/* ══ RUNNING BALANCE ══ */}
//         <div style={{
//           ...card({
//             padding: "22px 28px", marginBottom: 20,
//             background: BANK_BAL < 50000 ? "linear-gradient(135deg,#fffbeb,#fef9c3)" : "linear-gradient(135deg,#f5f7ff,#eff2ff)",
//             border: BANK_BAL < 50000 ? "1px solid #fde68a" : "1px solid #c7d2fe",
//             display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 16,
//           })
//         }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
//             <div style={{ width: 48, height: 48, borderRadius: 14, background: BANK_BAL < 50000 ? "#fef9c3" : "#e0e7ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🏦</div>
//             <div>
//               <div style={{ fontSize: 11, fontWeight: 700, color: BANK_BAL < 50000 ? C.amber : C.accent, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 6 }}>
//                 Running Balance
//                 {BANK_BAL < 50000 && <span style={{ marginLeft: 8, padding: "2px 8px", borderRadius: 20, background: "#fef9c3", border: "1px solid #fde68a", fontSize: 10 }}>⚠ LOW</span>}
//               </div>
//               <DualAmt pkrVal={BANK_BAL} fxRate={FX_RATE} size="lg" colorPKR={BANK_BAL < 50000 ? C.amber : C.accent} colorUSD={BANK_BAL < 50000 ? "#d97706" : "#6366f1"} />
//             </div>
//           </div>
//           <div style={{ display: "flex", gap: 24 }}>
//             <div style={{ textAlign: "right" }}>
//               <div style={{ fontSize: 11, color: C.textMut, marginBottom: 3 }}>Balance as of</div>
//               <div style={{ fontSize: 13, fontWeight: 600, color: C.textPri }}>{BANK_AS_OF}</div>
//             </div>
//             <div style={{ width: 1, background: C.border, margin: "0 8px" }} />
//             <div style={{ textAlign: "right" }}>
//               <div style={{ fontSize: 11, color: C.textMut, marginBottom: 3 }}>Next remittance expected</div>
//               <div style={{ fontSize: 13, fontWeight: 700, color: C.amber }}>{NEXT_REM}</div>
//             </div>
//           </div>
//         </div>

//         {/* ══ KPI ROW ══ */}
//         <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 14, marginBottom: 20 }}>
//           {[
//             { label: "Remittances In", pkrVal: mData.remIn, sub: `$${mData.remUSD.toLocaleString()} · ${mData.remIn > 0 ? MONTHS_DATA[selectedMonth]?.remIn > 0 ? 2 : 0 : 0} transfers`, color: C.green, icon: "💵" },
//             { label: "Expenses Out", pkrVal: mData.expOut, sub: selectedMonth, color: C.red, icon: "📤" },
//             { label: "Net Cash Flow", pkrVal: mData.remIn - mData.expOut, sub: mData.remIn - mData.expOut >= 0 ? "Surplus" : "Deficit", color: (mData.remIn - mData.expOut) >= 0 ? C.green : C.red, icon: "⚖️" },
//             { label: "WHT Deducted", pkrVal: mData.wht, sub: "0.25% on remittances", color: C.amber, icon: "🧾" },
//           ].map((k, i) => (
//             <div key={i} style={card({ padding: "18px 20px" })}>
//               <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
//                 <span style={{ fontSize: 10, fontWeight: 700, color: C.textMut, letterSpacing: 0.6, textTransform: "uppercase" }}>{k.label}</span>
//                 <span style={{ fontSize: 18 }}>{k.icon}</span>
//               </div>
//               <DualAmt pkrVal={k.pkrVal} fxRate={FX_RATE} size="md" colorPKR={k.color} colorUSD={k.color + "cc"} />
//               <div style={{ fontSize: 11, color: C.textMut, marginTop: 8 }}>{k.sub}</div>
//             </div>
//           ))}
//         </div>

//         {/* ══ MAIN BOTTOM GRID ══ */}
//         <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr 1fr", gap: 16 }}>

//           {/* Location Breakdown */}
//           <div style={card({ padding: "20px" })}>
//             <div style={{ fontSize: 11, fontWeight: 700, color: C.textMut, letterSpacing: 0.8, textTransform: "uppercase", marginBottom: 16 }}>📍 By Office — {selectedMonth}</div>
//             {locRows.map(({ loc, budget, actual, overdueAmt, upcomingAmt }) => {
//               const color = LOC_COLORS[loc];
//               const pct = budget > 0 ? Math.min((actual / budget) * 100, 100) : 0;
//               const isActive = locFilter === loc;
//               const totalOwed = overdueAmt + upcomingAmt;
//               return (
//                 <div key={loc} onClick={() => setLocFilter(locFilter === loc ? "All" : loc)}
//                   style={{
//                     padding: "12px 14px", borderRadius: 11, marginBottom: 10, cursor: "pointer",
//                     background: isActive ? `${color}0d` : "#f9fafb",
//                     border: `1px solid ${isActive ? color : C.border}`,
//                     transition: "all 0.15s",
//                   }}>
//                   {/* Row 1: name + amounts */}
//                   <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
//                     <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                       <span style={{ fontSize: 14 }}>{LOC_EMOJI[loc]}</span>
//                       <span style={{ fontSize: 13, fontWeight: 700, color: isActive ? color : C.textPri }}>{loc}</span>
//                     </div>
//                     <DualAmt pkrVal={actual} fxRate={FX_RATE} size="sm" colorPKR={color} colorUSD={C.textMut} />
//                   </div>
//                   {/* Budget bar */}
//                   <div style={{ height: 5, background: "#e5e7eb", borderRadius: 3, overflow: "hidden", marginBottom: 6 }}>
//                     <div style={{ height: "100%", width: `${pct}%`, background: color, borderRadius: 3 }} />
//                   </div>
//                   {/* Row 2: budget vs owed */}
//                   <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <span style={{ fontSize: 10, color: C.textMut }}>Budget: {pkr(budget)}</span>
//                     {totalOwed > 0
//                       ? <span style={{ fontSize: 10, fontWeight: 700, color: overdueAmt > 0 ? C.red : C.amber }}>
//                         {overdueAmt > 0 ? "⚠ " + pkr(totalOwed) + " owed" : "📋 " + pkr(totalOwed) + " due"}
//                       </span>
//                       : <span style={{ fontSize: 10, color: C.green, fontWeight: 600 }}>✓ Clear</span>
//                     }
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           {/* Overdue Bills */}
//           <div style={{ ...card({ padding: "20px", border: "1px solid #fecaca", background: "#fffbfb" }) }}>
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
//               <div style={{ fontSize: 11, fontWeight: 700, color: C.red, letterSpacing: 0.8, textTransform: "uppercase", display: "flex", alignItems: "center", gap: 6 }}>
//                 <span style={{ width: 8, height: 8, borderRadius: "50%", background: C.red, boxShadow: "0 0 0 3px #fecaca" }} />
//                 Overdue Bills
//               </div>
//               <span style={{ fontSize: 11, fontWeight: 700, color: C.red, padding: "2px 9px", borderRadius: 20, background: "#fef2f2", border: "1px solid #fecaca" }}>{filteredOverdue.length}</span>
//             </div>
//             <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 12 }}>
//               {filteredOverdue.map(b => (
//                 <div key={b.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 9, background: "#fef2f2", border: "1px solid #fee2e2" }}>
//                   <span style={{ fontSize: 14, flexShrink: 0 }}>{CAT_ICONS[b.cat] || "💳"}</span>
//                   <div style={{ flex: 1, minWidth: 0 }}>
//                     <div style={{ fontSize: 11.5, fontWeight: 600, color: "#7f1d1d", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{b.expense}</div>
//                     <div style={{ fontSize: 10, color: "#ef4444", marginTop: 1, display: "flex", alignItems: "center", gap: 4 }}>
//                       <span style={{ padding: "1px 6px", borderRadius: 20, background: `${LOC_COLORS[b.loc]}18`, color: LOC_COLORS[b.loc], fontSize: 9, fontWeight: 700 }}>{b.loc}</span>
//                       <span>{b.month}</span>
//                     </div>
//                   </div>
//                   <div style={{ textAlign: "right", flexShrink: 0 }}>
//                     <div style={{ fontSize: 12, fontWeight: 800, color: C.red }}>{pkr(b.pkr)}</div>
//                     <div style={{ fontSize: 10, color: "#ef4444", opacity: 0.7 }}>{usd(b.pkr, FX_RATE)}</div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <div style={{ padding: "12px 14px", borderRadius: 10, background: "#fef2f2", border: "1px solid #fecaca", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//               <span style={{ fontSize: 12, fontWeight: 700, color: "#9f1239" }}>Total Overdue</span>
//               <DualAmt pkrVal={filteredOvTotal} fxRate={FX_RATE} size="sm" colorPKR={C.red} colorUSD="#ef4444" />
//             </div>
//           </div>

//           {/* Upcoming Bills */}
//           <div style={card({ padding: "20px" })}>
//             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
//               <div style={{ fontSize: 11, fontWeight: 700, color: C.textMut, letterSpacing: 0.8, textTransform: "uppercase" }}>⏳ Upcoming — March</div>
//               <span style={{ fontSize: 11, color: C.textMut }}>{filteredUpcoming.length} bills</span>
//             </div>
//             <div style={{ display: "flex", flexDirection: "column", gap: 5, marginBottom: 12, maxHeight: 300, overflowY: "auto" }}>
//               {filteredUpcoming.map(b => {
//                 const isToday = b.dueDay === TODAY_DAY;
//                 const isSoon = b.dueDay && b.dueDay > TODAY_DAY && b.dueDay <= TODAY_DAY + 5;
//                 const isLate = b.dueDay && b.dueDay < TODAY_DAY;
//                 const locColor = LOC_COLORS[b.loc] || C.accent;
//                 const bg = isLate || isToday ? "#fef2f2" : isSoon ? "#fffbeb" : "#f9fafb";
//                 const border = isLate || isToday ? "#fecaca" : isSoon ? "#fde68a" : C.border;
//                 return (
//                   <div key={b.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 11px", borderRadius: 9, background: bg, border: `1px solid ${border}` }}>
//                     <span style={{ fontSize: 13, flexShrink: 0 }}>{CAT_ICONS[b.cat] || "💳"}</span>
//                     <div style={{ flex: 1, minWidth: 0 }}>
//                       <div style={{ fontSize: 11.5, fontWeight: 500, color: C.textPri, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{b.expense}</div>
//                       <div style={{ fontSize: 10, color: C.textMut, marginTop: 1, display: "flex", alignItems: "center", gap: 4 }}>
//                         <span style={{ padding: "1px 6px", borderRadius: 20, background: `${locColor}18`, color: locColor, fontSize: 9, fontWeight: 700 }}>{b.loc}</span>
//                         <span>{b.dueDay ? `${ord(b.dueDay)} Mar` : "On receipt"}</span>
//                         {isLate && <span style={{ color: C.red, fontWeight: 700 }}>⚠ Overdue</span>}
//                         {isToday && <span style={{ color: C.red, fontWeight: 700 }}>Due today</span>}
//                         {isSoon && <span style={{ color: C.amber, fontWeight: 700 }}>⚡ Due soon</span>}
//                       </div>
//                     </div>
//                     <div style={{ textAlign: "right", flexShrink: 0 }}>
//                       <div style={{ fontSize: 12, fontWeight: 700, color: isLate || isToday ? C.red : C.textPri }}>{pkr(b.pkr)}</div>
//                       <div style={{ fontSize: 10, color: C.textMut }}>{usd(b.pkr, FX_RATE)}</div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//             <div style={{ padding: "12px 14px", borderRadius: 10, background: "#fffbeb", border: "1px solid #fde68a", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//               <span style={{ fontSize: 12, fontWeight: 700, color: "#92400e" }}>Total Due — March</span>
//               <DualAmt pkrVal={filteredUpTotal} fxRate={FX_RATE} size="sm" colorPKR={C.amber} colorUSD="#d97706" />
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }